import { render, staticRenderFns } from "./TeleMedicine.vue?vue&type=template&id=c6b883c0&scoped=true"
import script from "./TeleMedicine.vue?vue&type=script&lang=js"
export * from "./TeleMedicine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6b883c0",
  null
  
)

export default component.exports